import { createAsyncThunk } from "@reduxjs/toolkit";
import { PagesMetadata } from "src/@types/pagesMetadata";
import { instance } from "src/services/api-client";

export const METADATA_SLICE_NAME = "meta";

export const getMetaDataAsync = createAsyncThunk(
  `${METADATA_SLICE_NAME}/fetchMetadata`,
  async () => {
    try {
      const { data } = await instance.get<PagesMetadata>("/meta/");
      return data;
    } catch (e) {
      console.error("faild to fetch metadata");
    }
  }
);
